import MyAccount from './MyAccount';

export default MyAccount;


// WEBPACK FOOTER //
// ./src/components/MyAccount/index.jsx